import React from 'react';
import './EmptyContent.less';
import Picture from '../../../../components/picture/Picture';

/**
 * 可选参数
 */
interface IProps {
	title?: any;
}

/**
 * EmptyContent
 */
class EmptyContent extends React.PureComponent<IProps> {
	/**
	 * render
	 */
	public render(): any {
		return (
			<div className="p-empty-content">
				<Picture src="https://img.qlchat.com/qlLive/activity/image/SW7UMRK3-9644-2WUN-1604908756279-6572GNP4DZ7T.png" placeholder className="empty-logo" />
				<p className="empty-holder">没有任何内容哦</p>
			</div>
		);
	}
}

export default EmptyContent;
